<template>
    <div>
        <el-select v-model="filterData.year" :placeholder="$t('Year')" @change="getUpdatedData" size="small" style="width:100px;float:right;" filterable>
            <el-option v-for="year in years" :value="year" :key="year"></el-option>
        </el-select>
        <horizontal-bar-chart :chart-data="datacollection" :options="options" style="max-height:400px;" />
    </div>
</template>

<script>
    import HorizontalBarChart from "../js/horizontalBar.js";
    export default {
        components: {
            HorizontalBarChart
        },
        computed: {
            years() {
                const year = new Date().getFullYear()
                return Array.from({
                    length: year - 2009
                }, (value, index) => 2010 + index)
            }
        },
        data() {
            return {
                datacollection: {},
                options: null,
                filterData: {
                    year: new Date().getFullYear()
                }
            }
        },
        mounted() {
            this.fillData()
        },
        methods: {
            getUpdatedData() {
                this.fillData();
            },
            isMobileDevice(){
                return ( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
            },
            fillData() {
                request({
                    url: "patenkinders-per-fachstellen",
                    method: "get",
                    params: this.filterData
                }).then(response => {
                    this.datacollection = response.data.data;
                });

                this.options = {
                    type: 'horizontalBar',
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [{
                            ticks: {
                                padding: 15,
                                display: !this.isMobileDevice()
                            },
                            gridLines: {
                                drawTicks: false,
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                padding: 15,
                                beginAtZero: true,
                                precision: 0
                            },
                            gridLines: {
                                drawTicks: false,
                            }
                        }]
                    },
                    hover: {
                        mode: null
                    },
                }
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/Layout/Widgets/chart/components/FachstellenPatenkinder.vue